<template>
  <div>
    <div class="v-content-card text-right" v-if="type == 'list'">
      <v-btn
        v-if="permission('write', 'financial_debit')"
        @click="handleNewRecord('spent')"
        class="btn-modern btn-modern-delete"
        ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR DÉBITO</v-btn
      >
      <v-btn
        v-if="permission('write', 'financial_credit')"
        @click="handleNewRecord('gain')"
        class="btn-modern btn-modern-save m-1"
        ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR CRÉDITO</v-btn
      >
      <v-btn
        v-if="permission('write', 'financial_transfer')"
        @click="handleNewRecord('transfer')"
        class="btn-modern btn-modern-info m-1"
        ><i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR TRANSFERÊNCIA</v-btn
      >
    </div>

    <List v-if="type == 'list'" />

    <Spent
      v-if="type == 'spent'"
      @success="handleSuccess"
      @cancel="handleCancel"
      finance_launch_bills_to_pay_type="CONTAS_A_PAGAR"
    />

    <Gain
      v-if="type == 'gain'"
      @success="handleSuccess"
      @cancel="handleCancel"
      finance_launch_bills_to_pay_type="CONTAS_A_RECEBER"
    />

    <Transfer
      v-if="type == 'transfer'"
      @success="handleSuccess"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import List from "./Releases/List";

import Spent from "./Releases/SpentGain";

import Gain from "./Releases/SpentGain";

import Transfer from "./Releases/Transfer";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "Releases",
  components: {
    List,
    Spent,
    Gain,
    Transfer,
  },
  data() {
    return {
      type: "list",
      data: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    retrieve() {
      const { launch } = routes.history.current.query;

      if (launch) {
        this.type = launch;
      } else {
        this.type = "list";
      }
    },
    handleNewRecord(type) {
      let { nav, launch } = routes.history.current.query;

      if (type != launch) {
        routes.replace({ query: { nav, launch: type } });
      }

      this.type = type;
    },
    handleSuccess() {
      let { nav } = routes.history.current.query;
      routes.replace({ query: { nav } });
      this.type = "list";
    },
    handleCancel() {
      let { nav } = routes.history.current.query;
      routes.replace({ query: { nav } });
      this.type = "list";
    },
  },
};
</script>
